export default {"src":"/_next/static/media/playstore.910aca3d.svg","height":51,"width":41,"blurWidth":0,"blurHeight":0};